var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"WhiteLabel"},[_c('KTCard',{attrs:{"title":_vm.$t('GENERAL.WAIT_CHANGING_WHITE_LABEL')},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Spinning"}})],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }